import { TriggeredMessagesResult } from 'modules/campaignsSentMessagesLogs/types';
import { useState } from 'react';
import styled from 'styled-components';
import { Button, BUTTON_VARIANTS } from 'ui/button';
import { Send16, View16 } from 'ui/icons';
import { Link } from 'ui/links';
import { Tooltip } from 'ui/tooltip';
import { setParams } from 'utils/urlParams';
import { ResendConfirmationModal } from '../resendConfirmationModal';
import { useResendMessage } from '../../hooks';

const Row = styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
`;

const StyledButton = styled(Button)`
z-index: 0;
`;

const displayContent = {
  resendBtn: 'Resend',
  resendTooltip: 'Resend message',
  viewBtn: 'View',
};

const VIEW_SENT_MESSAGE_URL = '/triggered/viewSentEmail';

export const ActionColumn = ({ row }: { row: TriggeredMessagesResult }) => {
  const { messageId, recipient, campaignName, messageMedium } = row;
  const { resendMessage, isLoading } = useResendMessage({
    campaignName,
    requestParams: {
      messageId,
      recipient,
      messageMedium,
    },
  });
  const [isResendModalOpen, setIsResendModalOpen] = useState(false);

  const handleSubmit = () => {
    resendMessage();
    setIsResendModalOpen(false);
  };

  return (
    <Row>
      <Tooltip tooltipContent={displayContent.resendTooltip}>
        <StyledButton
          variant={BUTTON_VARIANTS.GHOST}
          onClick={() => setIsResendModalOpen(true)}
          isLoading={isLoading}
        >
          <Send16 />
          {displayContent.resendBtn}
        </StyledButton>
      </Tooltip>
      <Link
        href={setParams(VIEW_SENT_MESSAGE_URL, {
          messageId,
          recipient,
        })}
      >
        <StyledButton variant={BUTTON_VARIANTS.GHOST}>
          <View16 />
          {displayContent.viewBtn}
        </StyledButton>
      </Link>
      {isResendModalOpen && (
        <ResendConfirmationModal
          isOpen={isResendModalOpen}
          onClose={() => setIsResendModalOpen(false)}
          onSubmit={handleSubmit}
          recipient={recipient}
          campaignName={campaignName}
        />
      )}
    </Row>
  );
};
